export default "__VITE_ASSET__BNF5lI_x__"